// eslint-disable-next-line no-restricted-imports
import { useIntl } from '@capsicum/common';

export type WalletButtonsProps = {
	balance?: number;
	isUsaRegulation: boolean;
	ledgerLimitData: undefined | unknown;
	tokenBalance?: string;
};

export type WalletButtonsAction = 'receive' | 'topUp' | 'withdraw';
export type WalletButtonsIcons = 'PlusIcon' | 'ReceiveArrowIcon' | 'WithdrawArrowIcon';
export type WalletButtonsState = 'disabled' | 'enabled' | 'pending';

export type WalletButton = {
	bottomText: string;
	icon: string | WalletButtonsIcons;
	state: WalletButtonsState;
	testID: string;
	to: string | WalletButtonsAction;
};

/**
 * Helper hook to create the button list depending on the regulation
 *
 * @param balance - to validate if some buttons needs to be disabled
 * * @param tokenBalance - to validate if some buttons needs to be disabled
 * @param isUsaRegulation - the returned button list will depend on the regulation
 */
export const useWalletButtons = ({ balance, isUsaRegulation, ledgerLimitData, tokenBalance }: WalletButtonsProps) => {
	const { $t } = useIntl();

	// Whether you can withdraw depends on your balance
	let withdrawState: WalletButtonsState = 'pending';

	if (balance !== undefined) {
		const notEnoughToWithdraw =
			!!(!balance || Number(balance) <= 0) && !!(!tokenBalance || Number(tokenBalance) <= 0);

		withdrawState = notEnoughToWithdraw ? 'disabled' : 'enabled';
	}

	let topupState: WalletButtonsState = 'pending';

	if (ledgerLimitData) {
		topupState = 'enabled';
	}

	const walletButtonsLabels = (action: WalletButtonsAction) => {
		const labels = {
			receive: $t('wallet.actionBar.receive'),
			topUp: $t('wallet.actionBar.topUp'),
			withdraw: $t('wallet.actionBar.withdraw')
		};

		return labels[action];
	};
	const walletButtons: Array<WalletButton> = [
		{
			bottomText: walletButtonsLabels('withdraw'),
			icon: 'WithdrawArrowIcon',
			state: withdrawState,
			testID: 'wallet-withdraw-button',
			to: 'withdraw'
		},
		...(isUsaRegulation
			? []
			: [
					{
						bottomText: walletButtonsLabels('receive'),
						icon: 'ReceiveArrowIcon',
						state: 'enabled' as const,
						testID: 'wallet-receive-button',
						to: 'receive'
					}
				]),

		{
			bottomText: walletButtonsLabels('topUp'),
			icon: 'PlusIcon',
			state: topupState,
			testID: 'wallet-top-up-button',
			to: 'topup'
		}
	];

	return {
		walletButtons
	};
};
